<template>
	<div class="analytics">
		<form @submit.prevent="search">
			<ManagingSection>
				<ManagingBox title="기간">
					<DateRange v-model="analyticsRange" type="date" />
				</ManagingBox>
				<ManagingBox title="기간 종류">
					<RadioList
						:radioList="searchTypeList"
						:value="searchType"
						@input="changeRange"
					/>
				</ManagingBox>
				<div class="btn-wrap-main">
					<button class="btn-main blue" type="submit">
						검색하기
					</button>
					<button
						class="btn-main"
						type="button"
						@click="searchInit()"
					>
						검색조건 초기화
					</button>
				</div>
			</ManagingSection>
		</form>
		<ManagingSection :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left"></div>
				<div class="section__info__right">
					<button
						class="btn-excel section__info__items"
						type="button"
						@click="excelDown"
					>
						엑셀 다운로드
					</button>
				</div>
			</template>
			<table class="table-main analytics__table">
				<thead>
					<tr>
						<th rowspan="2">기간</th>
						<th colspan="2">회원</th>
						<th>브랜드</th>
						<th colspan="3">제품</th>
						<th colspan="2">성분</th>
						<th colspan="4">리뷰</th>
						<th colspan="2">리뷰어</th>
						<th colspan="2">이벤트</th>
					</tr>
					<tr>
						<th>신규</th>
						<th>탈퇴</th>
						<th>신규</th>
						<th>등록</th>
						<th>등록요청</th>
						<th>수정요청</th>
						<th>등록</th>
						<th>등록요청</th>
						<th>등록</th>
						<th>신고</th>
						<th>블라인드</th>
						<th>좋아요</th>
						<th>등록</th>
						<th>리터닝(전월기준)</th>
						<th>오픈</th>
						<th>덧글</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in list" :key="index">
						<td>{{ item.date }}</td>
						<td>{{ item.newUserCount }}</td>
						<td>{{ item.outUserCount }}</td>
						<td>{{ item.newBrandCount }}</td>
						<td>{{ item.newProductCount }}</td>
						<td>{{ item.newRequestCount }}</td>
						<td>{{ item.editRequestCount }}</td>
						<td>{{ item.factorRegistCount }}</td>
						<td>{{ item.factorRequestCount }}</td>
						<td>{{ item.newReviewCount }}</td>
						<td>{{ item.reportReviewCount }}</td>
						<td>{{ item.blindReviewsCount }}</td>
						<td>{{ item.likeReviewCount }}</td>
						<td>{{ item.newReviewerCount }}</td>
						<td>{{ item.retentionReviewerCount }}</td>
						<td>{{ item.newEventCount }}</td>
						<td>{{ item.newEventReplyCount }}</td>
					</tr>
					<tr class="analytics__sum">
						<td>합계</td>
						<td v-for="(sum, index) in sumList" :key="index">
							{{ sum }}
						</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
	</div>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import DateRange from '@/components/DateRange.vue';
	import RadioList from '@/components/RadioList.vue';
	import moment from 'moment';
	import util from '@/util';

	export default {
		components: {
			ManagingSection,
			ManagingBox,
			DateRange,
			RadioList,
		},
		data() {
			return {
				list: [],
				sumList: [],
				analyticsRange: {
					from: '',
					to: '',
				},
				searchTypeList: [
					{ id: 'day', value: '일별' },
					{ id: 'month', value: '월별' },
					{ id: 'year', value: '년별' },
				],
				searchType: 'day',
				excelTitle: [
					'신규회원',
					'탈퇴회원',
					'신규브랜드',
					'제품등록',
					'제품등록요청',
					'제품수정요청',
					'성분등록',
					'성분등록요청',
					'리뷰등록',
					'리뷰신고',
					'리뷰블라인드',
					'리뷰좋아요',
					'리뷰어등록',
					'리뷰어리터닝',
					'이벤트오픈',
					'이벤트덧글',
				],
			};
		},
		created() {
			this.getOneMonthPeriod();
			this.setFilter();
			this.getList();
		},
		methods: {
			async getList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/operation/statistic/all?startDate=${this.analyticsRange.from}&endDate=${this.analyticsRange.to}&sort=${this.searchType}`
					);
					this.list = data;
					this.clacSum();
				} catch (error) {
					console.error(error);
					alert('데이터를 불러오는데 실패했습니다.');
				}
			},
			clacSum() {
				const keys = [
					'newUserCount',
					'outUserCount',
					'newBrandCount',
					'newProductCount',
					'newRequestCount',
					'editRequestCount',
					'factorRegistCount',
					'factorRequestCount',
					'newReviewCount',
					'reportReviewCount',
					'blindReviewsCount',
					'likeReviewCount',
					'newReviewerCount',
					'retentionReviewerCount',
					'newEventCount',
					'newEventReplyCount',
				];
				const sums = keys.reduce((acc, key) => {
					acc[key] = this.list.reduce(
						(sum, item) => sum + item[key],
						0
					);
					return acc;
				}, {});

				this.sumList = Object.values(sums);
			},
			search() {
				this.getList();
				this.replaceQuery();
			},
			searchInit() {
				this.searchType = 'day';
				this.getOneMonthPeriod();
			},
			getOneMonthPeriod() {
				const today = moment().format('YYYY-MM-DD');
				const startDate = moment()
					.startOf('month')
					.format('YYYY-MM-DD');
				this.analyticsRange = {
					from: startDate,
					to: today,
				};
			},
			changeRange($event) {
				this.searchType = $event;
			},
			replaceQuery() {
				this.$router.replace({
					query: {
						startDate: this.analyticsRange.from,
						endDate: this.analyticsRange.to,
						sort: this.searchType,
					},
				});
			},
			setFilter() {
				const query = this.$route.query;
				if (query.startDate && query.endDate && query.sort) {
					this.analyticsRange = {
						from: query.startDate,
						to: query.endDate,
					};
					this.searchType = query.sort;
				}
			},
			async excelDown() {
				const { data, config } = await this.$axiosAdmin2.get(
					`/api/operation/statistic/all?startDate=${this.analyticsRange.from}&endDate=${this.analyticsRange.to}&sort=${this.searchType}`
				);
				const rows = data.map(item => [
					item.date,
					item.newUserCount,
					item.outUserCount,
					item.newBrandCount,
					item.newProductCount,
					item.newRequestCount,
					item.editRequestCount,
					item.factorRegistCount,
					item.factorRequestCount,
					item.newReviewCount,
					item.reportReviewCount,
					item.blindReviewsCount,
					item.likeReviewCount,
					item.newReviewerCount,
					item.retentionReviewerCount,
					item.newEventCount,
					item.newEventReplyCount,
				]);
				const title = `글로우픽_통계(${this.analyticsRange.from} ~ ${this.analyticsRange.to}_${new Date().getTime()})`;
				util.getCsv(
					[rows],
					[title],
					[
						[
							'날짜',
							'신규회원',
							'탈퇴회원',
							'신규브랜드',
							'제품등록',
							'제품등록요청',
							'제품수정요청',
							'성분등록',
							'성분등록요청',
							'리뷰등록',
							'리뷰신고',
							'리뷰블라인드',
							'리뷰좋아요',
							'리뷰어등록',
							'리뷰어리터닝',
							'이벤트오픈',
							'이벤트덧글',
						],
					],
					title,
					config.url
				);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.analytics {
		&__sum {
			font-weight: bold;
			background-color: #f4f7fa;
		}
	}
</style>
